import type { FC } from 'react';
import React from 'react';
import { styled } from '@compiled/react';

import AkSpinner from '@atlaskit/spinner/spinner';
import { token } from '@atlaskit/tokens';

import { InfiniteScroll } from './InfiniteScroll.tsx';

type ObservableSpinnerProps = {
	onScrollTo: () => void;
	testId: string;
	// If the cursor is not passed in, onScrollTo will only be called once.
	cursor?: string | null | undefined;
	observerOptions: IntersectionObserverInit;
	spinnerSize?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SpinnerWrapper = styled.div({
	width: '100%',
	height: '40px',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SpinnerContainer = styled.div({
	minHeight: '24px',
	padding: `${token('space.100')} 0`,
	overflow: 'hidden',
});

export const ObservableSpinner: FC<ObservableSpinnerProps> = ({
	onScrollTo,
	testId,
	cursor,
	observerOptions,
	spinnerSize = 'medium',
}: ObservableSpinnerProps) => {
	return (
		<InfiniteScroll onScrollTo={onScrollTo} cursor={cursor} observerOptions={observerOptions}>
			<SpinnerWrapper>
				<SpinnerContainer>
					<AkSpinner size={spinnerSize} testId={testId} />
				</SpinnerContainer>
			</SpinnerWrapper>
		</InfiniteScroll>
	);
};
